export function accordion() {
    if( !$(".category-box").length ){
        $(".accordion-content").eq(0).stop(true,true).slideToggle("200");
        $(".accordion-item").eq(0).addClass("active");
    }
    $(".accordion-title").click(function (){
        var $this = $(this);
        $this.next(".accordion-content").stop(true,true).slideToggle("200");
        $this.parent().toggleClass("active");
        $this.parent().siblings(".accordion-item").children(".accordion-content").stop(true,true).slideUp("200");
        $this.parent().siblings(".accordion-item").removeClass("active");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/accordion.js